module.exports = __webpack_public_path__ + "img/section-money-back-guarantee.15d17c94.jpg";